import Common from '../common.js';

export default {
    feedbacks: function (feedBackTypeId, async, start,  page, count, sortField, sortDir, successCallback, errorCallback) {
        var queryParams = '?';
        if (feedBackTypeId != null) {
            queryParams += 'feedBackTypeId=' + feedBackTypeId + '&';
        }
        if (start != null) {
            queryParams += 'start=' + start + '&';
        }
        if (page != null) {
            queryParams += 'page=' + page + '&';
        }
        if (count != null) {
            queryParams += 'count=' + count + '&';
        }
        if (sortField != null) {
            queryParams += 'sortField=' + sortField + '&';
        }
        if (sortDir != null) {
            queryParams += 'sortDir=' + sortDir + '&';
        }

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/feedback' + queryParams,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json',
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },
    saveFeedback: function (model, async) {
        var result = null;

        $.ajax({
            url: Application.getBasePath() + '/platform/api/feedback/add',
            type: 'POST',
            data: $.toJSON(model),
            dataType: "json",
            async: async,
            contentType: 'application/json',
            success: function (data, textStatus) {
                Common.showToast('success', 'Успех', 'Ваше обращение принято, ждите ответа на указанный e-mail');
                result = data.id;
            },
            error: function (jqXHR, data, textStatus) {
                Common.showToast('error', 'Ошибка', 'Не удалось произвести отправку обращения');
            }
        });


        return result;
    }
};



// WEBPACK FOOTER //
// ./src/api/feedback.js